import "./onyx-os-signature.css";

/** Brand signature for ONYX OS with a distinct OS typographic accent. */
export default function OnyxOsSignature() {
  return <span className="onyxos-signature">ONYX <strong className="onyxos-signature-os">OS</strong></span>;
}
